import PropTypes from 'prop-types';

const propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    fundType: PropTypes.string,
    fundAssetClass: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    inceptionDate: PropTypes.string,
    minimumInvestment: PropTypes.number,
    managementFee: PropTypes.string,
    performanceFee: PropTypes.string,
    totalCostRatio: PropTypes.string,
    financialYearEndFeesDate: PropTypes.string,
    performance: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })).isRequired,
    company: PropTypes.shape({
      name: PropTypes.string.isRequired,
      logoColor: PropTypes.string,
      logoPictureUrl: PropTypes.string,
    }).isRequired,
    fundInvestorVehicleType: PropTypes.string,
    wholesale: PropTypes.bool.isRequired,
  }).isRequired,
};

const fundCardPropTypes = {
  name: PropTypes.string.isRequired,
  fundType: PropTypes.string.isRequired,
  fundAssetClass: PropTypes.string.isRequired,
  inceptionDate: PropTypes.string.isRequired,
  minimumInvestment: PropTypes.number,
  managementFee: PropTypes.string,
  performanceFee: PropTypes.string,
  totalCostRatio: PropTypes.string,
  financialYearEndFeesDate: PropTypes.string,
  returnSinceInception: PropTypes.string.isRequired,
  logoColor: PropTypes.string,
  logoPictureUrl: PropTypes.string,
  fundInvestorVehicleType: PropTypes.string,
  wholesale: PropTypes.bool.isRequired,
};

const fundCardDefaultPropTypes = {
  minimumInvestment: null,
  logoColor: null,
  logoPictureUrl: null,
  managementFee: null,
  performanceFee: null,
  totalCostRatio: null,
  financialYearEndFeesDate: null,
  fundInvestorVehicleType: null,
};

const topRatedFundsSeriesPropTypes = {
  topRatedFundSeriesDesktopBackground: PropTypes.string.isRequired,
  topRatedFundSeriesMobileBackground: PropTypes.string.isRequired,
  topRatedFundSeriesLogo: PropTypes.string.isRequired,
};

const incomeSeriesPropTypes = {
  incomeSeriesBackground: PropTypes.string.isRequired,
  incomeSeriesLogo: PropTypes.string.isRequired,
  incomeSeriesLogoHorizontal: PropTypes.string.isRequired,
};

export {
  propTypes,
  fundCardPropTypes,
  fundCardDefaultPropTypes,
  topRatedFundsSeriesPropTypes,
  incomeSeriesPropTypes,
};
